module.exports = __webpack_public_path__ + "img/fig13.6a3341e5.jpg";